import React from 'react';
import clsx from 'clsx';
import styles from './PlaceholderCard.module.scss';

const PlaceholderCard = ({
  children,
  onClick,
}) => {
  const className = clsx(styles.PlaceholderCard, {
    [styles['PlaceholderCard--clickable']]: !!onClick,
  });

  return (
    <div className={className} onClick={onClick}>
      {children}
    </div>
  );
};

export default PlaceholderCard;
